// extracted by mini-css-extract-plugin
module.exports = {"soundVolume":"SoundVolume_soundVolume__2RBG4","soundVolumeAnimate":"SoundVolume_soundVolumeAnimate__2XINZ","soundAnimation":"SoundVolume_soundAnimation__R9mN2"};